import { createApp, defineAsyncComponent } from 'vue';

const runWhenIdle = window.requestIdleCallback
    ? (fn) => window.requestIdleCallback(fn, { timeout: 2000 })
    : (fn) => setTimeout(fn, 200);

// Syntax highlighting: only fetched/parsed on pages that actually have code blocks.
runWhenIdle(() => {
    if (! document.querySelector('pre code')) {
        return;
    }

    import('highlight.js/lib/core').then(({ default: hljs }) => {
        Promise.all([
            import('highlight.js/lib/languages/bash'),
            import('highlight.js/lib/languages/css'),
            import('highlight.js/lib/languages/xml'),
            import('highlight.js/lib/languages/javascript'),
            import('highlight.js/lib/languages/json'),
            import('highlight.js/lib/languages/markdown'),
            import('highlight.js/lib/languages/php'),
            import('highlight.js/lib/languages/scss'),
            import('highlight.js/lib/languages/yaml'),
        ]).then(([bash, css, html, javascript, json, markdown, php, scss, yaml]) => {
            hljs.registerLanguage('bash', bash.default);
            hljs.registerLanguage('css', css.default);
            hljs.registerLanguage('html', html.default);
            hljs.registerLanguage('javascript', javascript.default);
            hljs.registerLanguage('json', json.default);
            hljs.registerLanguage('markdown', markdown.default);
            hljs.registerLanguage('php', php.default);
            hljs.registerLanguage('scss', scss.default);
            hljs.registerLanguage('yaml', yaml.default);

            document.querySelectorAll('pre code').forEach((block) => {
                hljs.highlightElement(block);
            });
        });
    });
});

// Search UI: mounted off the critical path; the Search component (and fuse.js
// inside it) load as a separate chunk instead of bloating the initial bundle.
runWhenIdle(() => {
    createApp({
        components: {
            Search: defineAsyncComponent(() => import('./components/Search.vue')),
        },
    }).mount('#vue-search');
});

